import { useTranslation } from "react-i18next";

export const isCalendlyEvent = (e: MessageEvent<any>) => {
  return (
    e.origin === "https://calendly.com" &&
    e.data.event &&
    e.data.event.indexOf("calendly.") === 0
  );
};

export const useGetCalendlyHostIntakeMeetingUrl = () => {
  const { i18n } = useTranslation("host");

  let base;
  if (i18n.language === "nl") {
    base = process.env.REACT_APP_CALENDLY_MEETING_URL!;
  } else {
    base = process.env.REACT_APP_CALENDLY_MEETING_URL_GB!;
  }

  return base + "?hide_event_type_details=1&hide_gdpr_banner=1";
};
